export interface ICustomerProfile {
  parentTradingId: string
  subAccountId: string
  subAccountType: string
  accountStatus: string
  directTxnAllowed: boolean
  omsRms: number
  name: string
  email: string
  phoneNo: number
  clientType: string
  fatcaStatus: string
  rdStatus: string
  partnerCode: string
  groupId: string
  productId: string
  productsAllowed: IProductsAllowed
  segmentsEnabled: ISegmentsEnabled
  bankAccountDetails: IBankAccountDetails[]
  dpAccountDetails: IDPAccountDetails[]
  erdPanAadharFl: string
  riskProfileId: string
  emBrkgEqSchemeId: number
  incomeRange: object
  Device: IDeviceDetails[]
  panNumber: string
  cumulativePositionsAllowed: boolean
}

export interface IDPAccountDetails {
  dpId: string
  dpAccountNo: string
  ddpiPoa: boolean
  dpPOA: boolean
  edis: IDPEDIS
  dpDefault: boolean
}

interface IDPEDIS {
  isActive: boolean
  metadata?: {
    code: string
    error: string
  }
}
export interface IBankAccountDetails {
  bankCode: string
  bankStatus: string
  bankAccountNo: string
  bankCustId: string
  hrtAllowed: boolean
  isDefault: boolean
  hasPOA: boolean
  bankName: string
  ifscCode: string
  rzpFlag: boolean
  billFlag: boolean
  netbanking: boolean
  upi: boolean
  entBmlStatus: boolean
}

interface ISegmentsEnabled {
  nseCash: boolean
  nseFO: boolean
  nseCdx: boolean
  nseIPO: boolean
  bseCash: boolean
  mcxCmx: boolean
  ncdexCmx: boolean
  bseIPO: boolean
  bseMF: boolean
  mfd: boolean
}
interface IProductStatus {
  isActive: boolean
}

interface IProductStatusWithMetadata extends IProductStatus {
  metadata?: {
    code: string
    error: string
  }
}

export interface IProductsAllowed {
  cnc: IProductStatus
  cover: IProductStatus
  emargin: IProductStatusWithMetadata
  collateral: IProductStatus
  slbBse: IProductStatus
  slb: IProductStatus
  intraDay: IProductStatus
  spot: IProductStatus
  callsell: IProductStatus
  pledgeMargin: IProductStatusWithMetadata
  gtd: IProductStatusWithMetadata
  sip: IProductStatusWithMetadata
  commodity: IProductStatusWithMetadata
}

interface IDeviceDetails {
  platform: string
  deviceId: string
  createdAt: string
}

interface IInstrumentIdentity {
  instrumentIdType: number
  instrumentId: string
}

interface IMarginDetails {
  mtfDays: number
  emarginDays: number
  marginPercentage: number
  intradayPercentage: number
  coverPercentage: number
  eMarginPercentage: number
  coverCMPDifferencePercentage: number
  coverSLDifferencePercentage: number
}

interface ICommonPrivilegeDetails {
  cashAndCarryPrivilege: boolean
  marginPrivilege: boolean
  intradayPrivilege: boolean
  collateralPrivilege: boolean
  coverPrivilege: boolean
  spotPrivilege: boolean
  emarginPrivilege: boolean
}


/* -------------------------------------------------------------------------- */
/*                              MAIN REDUCER TYPE                             */
/* -------------------------------------------------------------------------- */
export interface ICustomerReducer {
  customerProfile: ICustomerProfile
}

export interface IReports {
  _id: string
  category: string
  description: string
  imageUrl: Record<string, string>
  redirectUrl: string
  showOnResearch: boolean
  ssoType: string
  title: string
}

/* -------------------------------------------------------------------------- */
/*                               DEFAULT VALUES                               */
/* -------------------------------------------------------------------------- */
const DEFAULT_VALUE_CUSTOMER_PROFILE = {
  parentTradingId: '',
  subAccountId: '',
  subAccountType: '',
  accountStatus: '',
  directTxnAllowed: false,
  omsRms: 0,
  name: '',
  email: '',
  phoneNo: 0,
  clientType: '',
  fatcaStatus: '',
  rdStatus: '',
  partnerCode: '',
  groupId: '',
  productId: '',
  productsAllowed: {
    cnc: { isActive: false },
    cover: { isActive: false },
    emargin: { isActive: false },
    collateral: { isActive: false },
    slbBse: { isActive: false },
    slb: { isActive: false },
    intraDay: { isActive: false },
    spot: { isActive: false },
    callsell: { isActive: false },
    pledgeMargin: {
      isActive: false,
      metadata: { code: '', error: '' }
    },
    gtd: {
      isActive: false,
      metadata: { code: '', error: '' }
    },
    sip: {
      isActive: false,
      metadata: { code: '', error: '' }
    },
    commodity: {
      isActive: false,
      metadata: { code: '', error: '' }
    }
  },
  segmentsEnabled: {
    nseCash: false,
    nseFO: false,
    nseCdx: false,
    nseIPO: false,
    bseCash: false,
    mcxCmx: false,
    ncdexCmx: false,
    bseIPO: false,
    bseMF: false,
    mfd: false
  },
  bankAccountDetails: [],
  dpAccountDetails: [],
  erdPanAadharFl: '',
  riskProfileId: '',
  emBrkgEqSchemeId: 0,
  incomeRange: {},
  Device: [],
  panNumber: '',
  cumulativePositionsAllowed: false
}

const DEFAULT_VALUE_EMARGIN_DETAILS = {
  instrumentIdentity: {
    instrumentIdType: 0,
    instrumentId: ''
  },
  marginDetails: {
    mtfDays: 0,
    emarginDays: 0,
    marginPercentage: 0,
    intradayPercentage: 0,
    coverPercentage: 0,
    eMarginPercentage: 0,
    coverCMPDifferencePercentage: 0,
    coverSLDifferencePercentage: 0
  },
  commonPrivilegeDetails: {
    cashAndCarryPrivilege: false,
    marginPrivilege: false,
    intradayPrivilege: false,
    collateralPrivilege: false,
    coverPrivilege: false,
    spotPrivilege: false,
    emarginPrivilege: false
  }
}

export const INITIAL_STATE: ICustomerReducer = {
  customerProfile: DEFAULT_VALUE_CUSTOMER_PROFILE
}
